
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import Dialog from '@/components/dialog.vue';
  import {
    orderSupportmodifySystemRemarkRecordList,
    orderSupportmodifySystemRemark
  } from "@/api/after_sales"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog':Dialog,
    }
  })

  export default class ProductList extends Vue {
    @Prop() show:boolean
    @Prop({default:()=>{}}) msg:any
    private dialogShow = false
    private bannerColor = {
      0:'#f92519',
      1:'#ef8733',
      2:'#2e63f6',
      3:'#1cac34',
      4:'#873df1',
    }
    private remarkMsg:any = {}
    private recordList:any = []
    @Watch('show')
    private watchShow(val){
      this.dialogShow = val
      if(val){
        this.remarkMsg = {
          SystemRemark:this.msg.SystemRemark||'',
          SystemRemarkFlag:this.msg.SystemRemarkFlag||0,
        }
        this.getRecord()
      }
    }

    private async getRecord(){
      try{
        let res = await orderSupportmodifySystemRemarkRecordList({
          SupportNo:this.msg.SupportNo
        })
        if(res.IsSuccess){
          this.recordList = res.Result
        }
      }finally{
        //
      }
    }
    
		private async saveremark() {
			try {
				let data = {
					SupportNo: this.remarkMsg.SupportNo,
					...this.remarkMsg
				}
				let res = await orderSupportmodifySystemRemark(data)
				if (res.IsSuccess) {
					this.$message.success('操作成功')
				}
			} finally {
				//
			}
		}
    private close(){
      this.dialogShow = false
      
      this.$emit('close',false)
    }
  }
